import { merge } from 'lodash-es';
import * as Yup from 'yup';
import { AchievementCheckOperatorType } from '../../../../dorian-shared/types/achievement/Achievement';
import { IAchievementModal } from '../AchievementsModalTypes';
import { convertYupErrorsToFormik } from './convertYupErrorsToFormik';

const achievementBaseSchema = {
  name: Yup.string()
    .min(2, 'Must be 2 characters or more')
    .max(254, 'Must be 254 characters or less')
    .required('Required')
    .matches(/^[a-zA-Z0-9_\-.$&]*$/, 'Only letters, numbers, and special characters are allowed'),
  displayName: Yup.string()
    .max(25, 'Must be 25 characters or less'),
  description: Yup.string()
    .max(254, 'Must be 254 characters or less'),
};

const rewardSchema = Yup.object().shape({
  contentId: Yup.string()
    .nullable()
    .notRequired(),
  type: Yup.number()
    .nullable()
    .notRequired(),
  delaySec: Yup.number()
    .nullable()
    .notRequired(),
});

const achievementAtLeastSchema = Yup.object().shape({
  ...achievementBaseSchema,
  icon: Yup.string().required('Required'),
  check: Yup.object().shape({
    variableId: Yup.number().min(1, 'Required').required('Required'),
    operator: Yup.string().required('Required'),
    value: Yup.number()
      .transform((value) => (Number.isNaN(value) ? null : value))
      .nullable()
      .required('Required')
      .max(999999999, 'Must be 999999999 or less'),
  }),
  rewards: Yup.array().of(rewardSchema),
});

const achievementHasCompletedSchema = Yup.object().shape({
  ...achievementBaseSchema,
  icon: Yup.string().nullable().notRequired(),
  check: Yup.object().shape({
    variableId: Yup.number().nullable().notRequired(),
    operator: Yup.string().required('Required'),
    value: Yup.string().required('Required'),
  }),
  rewards: Yup.array().of(rewardSchema),
});

const achievementAlternatePriceSchema = Yup.object().shape({
  ...achievementBaseSchema,
  icon: Yup.string().nullable().notRequired(),
  check: Yup.object().shape({
    variableId: Yup.number().nullable().notRequired(),
    operator: Yup.string().required('Required'),
    value: Yup.string().nullable().notRequired(),
  }),
  rewards: Yup.array().of(rewardSchema),
});

export function validateGeneral(values: IAchievementModal[], i: number, errors: { [p: string]: Record<string, any> }) {
  const errorsFound = { ...errors };
  try {
    const value = values[i];
    switch (value.check.operator) {
      case AchievementCheckOperatorType.AtLeast:
        achievementAtLeastSchema.validateSync(value, { abortEarly: false });
        break;
      case AchievementCheckOperatorType.HasCompleted:
        achievementHasCompletedSchema.validateSync(value, { abortEarly: false });
        break;
      case AchievementCheckOperatorType.Manual:
        achievementAlternatePriceSchema.validateSync(value, { abortEarly: false });
        break;
      default:
        achievementAtLeastSchema.validateSync(value, { abortEarly: false });
        break;
    }
  } catch (validationErrors) {
    if (validationErrors instanceof Yup.ValidationError) {
      validationErrors.inner.forEach((error) => {
        if (error.path) {
          errorsFound[i] = merge(errorsFound[i] || {}, convertYupErrorsToFormik(error));
        }
      });
      console.log('errors', i, errorsFound);
      console.log('values', i, values);
    } else {
      console.error(validationErrors);
    }
  }
  return errorsFound;
}

export const validateUniqueNames = (values: IAchievementModal[], i: number, errors: { [key: string]: Record<string, any> }) => {
  const errorsFound = { ...errors };
  const isNameExist = values.some((v, j) => v.name === values[i].name && j !== i);
  if (isNameExist) {
    errorsFound[i] = {
      ...errorsFound[i],
      name: 'Name should be unique',
    };
  }
  return errorsFound;
};
